// @flow

import composeCommentsDataTable from './datatable'
export default composeCommentsDataTable
